import { UseSearchState } from '@propertypal/shared/src/hooks/useSearchState';
import { SearchState } from '@propertypal/shared/src/reducers/search';
import { PropertyStyle } from '@propertypal/shared/src/types/propertyStyles';
import CheckItem from '@propertypal/web-ui/src/inputs/CheckItem';
import { RowWrap } from '@propertypal/web-ui/src/layout';
import { InputLabel } from '@propertypal/web-ui/src/typography';
import React, { FunctionComponent } from 'react';
import { getPropertyStyleIcon } from '../../../constants/styleIcons';
import { StyleGrid, checkItemStyles } from './SearchBar.style';

interface Props {
  filters: SearchState['filters'];
  propertyStyles: PropertyStyle[] | null;
  handleStyleChange: UseSearchState['handleStyleChange'];
  isMobile?: boolean;
}

const StyleInputs: FunctionComponent<Props> = ({ filters, propertyStyles, handleStyleChange, isMobile }) => {
  if (!propertyStyles || propertyStyles.length === 0) {
    return null;
  }

  const onChange = (key: string) => (value: boolean) => {
    handleStyleChange(key)(value);
  };

  return (
    <>
      <InputLabel id="propertyTypesLabel">Property Types</InputLabel>

      {isMobile && (
        <StyleGrid>
          {propertyStyles.map((style) => (
            <CheckItem
              key={style.key}
              checked={filters.styles.includes(style.key)}
              label={style.text}
              checkedIcon={getPropertyStyleIcon(filters.category, style.key, true)}
              unCheckedIcon={getPropertyStyleIcon(filters.category, style.key, false)}
              onValueChange={onChange(style.key)}
              testID={`checkItem-${style.key}`}
            />
          ))}
        </StyleGrid>
      )}

      {!isMobile && (
        <RowWrap role="group" aria-labelledby="propertyTypesLabel">
          {propertyStyles.map((style) => (
            <CheckItem
              key={style.key}
              containerStyle={checkItemStyles}
              checked={filters.styles.includes(style.key)}
              label={style.text}
              checkedIcon={getPropertyStyleIcon(filters.category, style.key, true)}
              unCheckedIcon={getPropertyStyleIcon(filters.category, style.key, false)}
              onValueChange={onChange(style.key)}
              testID={`checkItem-${style.key}`}
            />
          ))}
        </RowWrap>
      )}
    </>
  );
};

export default StyleInputs;
